export default "__VITE_ASSET__D68HRs5E__"